module.exports = __webpack_public_path__ + "img/bg-header@3x.506123e.jpg";